<template>
	<div
		class="d-flex flex-column justify-center align-center"
		style="
			background-color: #d2d6de;
			background-size: cover;
			background-attachment: fixed;
			min-height: 100vh;
			display: flex;
			flex-direction: column;
		"
	>
		<v-form
			ref="form"
			v-model="valid"
			@submit.prevent="validateEmail"
			v-if="showEmailForm"
		>
			<v-card width="360">
				<v-card-title
					class="title d-flex justify-center align-center mb-4"
					style="background-color: #003366; color: white"
				>
					<v-img
						max-width="150"
						:src="baseLocation + '/resource/image/v-unite-logo.png'"
					></v-img>
				</v-card-title>
				<v-card-text>
					<v-text-field
						v-model="email"
						:rules="emailRules"
						label="E-mail"
						required
						validate-on-blur
						@keyup.enter="validateEmail"
					></v-text-field>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4">
					<v-spacer></v-spacer>
					<v-btn
						type="submit"
						color="primary darken-1"
						depressed
						tile
						>Next</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-form>

		<v-form
			ref="form"
			v-model="valid"
			@submit.prevent="validatePassword"
			v-if="showPasswordForm"
		>
			<v-card width="360">
				<v-card-title
					class="title d-flex justify-center align-center mb-4"
					style="background-color: #003366; color: white"
				>
					<v-img
						max-width="150"
						:src="baseLocation + '/resource/image/v-unite-logo.png'"
					></v-img>
				</v-card-title>
				<v-card-text>
					<v-radio-group
						v-model="tenantId"
						v-if="tenantStaffList.length > 1"
					>
						<v-radio
							v-for="(tenant, idxTenant) in tenantStaffList"
							:key="idxTenant"
							:value="tenant.id"
							:label="tenant.name"
						>
						</v-radio>
					</v-radio-group>
					<v-text-field
						v-model="password"
						:rules="passwordRules"
						:type="passwordFieldType"
						:append-icon="
							passwordFieldType === 'password'
								? 'mdi-eye'
								: 'mdi-eye-off'
						"
						@click:append="switchVisibility"
						label="Password"
						required
						validate-on-blur
						@keyup.enter="validatePassword"
					></v-text-field>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4">
					<v-row>
						<v-col cols="8">
							<router-link class="v-unite-primary" :to="'/tenant/forgotpassword' " color="primary darken-1"
								style="margin-left:10px;color:#001e4e !important;font-size:12px"
							>Forgot Password</router-link>
						</v-col>
						<v-col cols="2">
						<v-btn
							type="submit"
							color="primary darken-1"
							depressed
							tile
							>Login</v-btn
						>
						</v-col>
						<v-col cols="12" style="font-size:12px;margin-left:10px;">
							<span> Browser compatibility check 
								<a href="https://v-unite.com/browser-check/">https://v-unite.com/browser-check/</a> 
							</span>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-form>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			email: "",
			emailRules: [
				(v) => !!v || "E-mail is required",
				(v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
			],
			password: "",
			passwordRules: [(v) => !!v || "Please specify password"],
			baseLocation: axios.defaults.baseURL,
			tenantStaffList: [],
			tenantId: null,
			showEmailForm: true,
			showPasswordForm: false,
			passwordFieldType: "password",
		};
	},
	methods: {
		login() {
			this.$store
				.dispatch("login", {
					type: "Tenant_Staff",
					email: this.email,
					password: this.password,
					tenantId: this.tenantId,
				})
				.then(() => this.$router.push("/tenant/dashboard"))
				.catch(() => {});
		},
		next() {
			axios
				.get("/system/authentication/tenant/list?email=" + this.email)
				.then((response) => {
					this.tenantStaffList = response.data;
					if (this.tenantStaffList.length == 1) {
						this.tenantId = this.tenantStaffList[0].id;
					}
					this.$refs.form.resetValidation();
					this.showEmailForm = false;
					this.showPasswordForm = true;
				})
				.catch(() => {});
		},
		switchVisibility() {
			this.passwordFieldType =
				this.passwordFieldType === "password" ? "text" : "password";
		},
		validateEmail() {
			this.$refs.form.validate();
			if (this.valid) {
				this.next();
			}
		},
		validatePassword() {
			this.$refs.form.validate();
			if (this.valid) {
				this.login();
			}
		},
	},
};
</script>